export default __webpack_public_path__ + "static/media/2.14.78cf0437.mp3";